<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>社交</el-breadcrumb-item>
      <el-breadcrumb-item>伏特获取记录</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row :gutter="20">
        <el-col :span="3">
          <el-input
            v-model="queryInfo.activityId"
            placeholder="请输入活动id"
            clearable
          ></el-input>
        </el-col>
        <!-- <el-col :span="4">
          <el-date-picker
            v-model="queryInfo.createTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择获取时间"
          >
          </el-date-picker>
        </el-col> -->
        <el-col :span="1">
          <el-button type="primary" @click="getVoltGetList">查询</el-button>
        </el-col>
      </el-row>

      <el-table :data="tableInfo.tableData" border>
        <el-table-column
          v-for="(item, index) in tableInfo.columns"
          :prop="item.prop"
          :label="item.label"
          :align="item.align"
          :key="index"
        >
          <template slot-scope="scope">
            <span
              v-if="item.prop == 'createTime' || item.prop == 'updateTime'"
              >{{ scope.row[item.prop] | filterTime }}</span
            >
            <span v-else-if="item.prop == 'isHave'">{{
              scope.row[item.prop] | filterIsHave
            }}</span>
            <span v-else-if="item.prop == 'isFree'">{{
              scope.row[item.prop] | filterIsFree
            }}</span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationInfo.pageNum"
        :page-sizes="[10,30,50]"
        :page-size="paginationInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paginationInfo.total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 搜索数据
      queryInfo: {
        activityId: "",
        // createTime: "",
      },
      // 表格数据
      tableInfo: {
        columns: [
          { label: "编号", prop: "id", width: 150, align: "center" },
          { label: "用户编号", prop: "userId", width: 150, align: "center" },
          { label: "中奖id", prop: "prizeId", width: 150, align: "center" },
          // { label: "用户活动商品id", prop: "activityGoodsId", width: 150, align: "center" },
          {
            label: "活动id",
            prop: "userActivityGoodsId",
            width: 150,
            align: "center",
          },
          { label: "是否兑换", prop: "isHave", width: 150, align: "center" },
          { label: "是否收费", prop: "isFree", width: 150, align: "center" },
          // {
          //   label: "创建时间",
          //   prop: "createTime",
          //   width: 150,
          //   align: "center",
          // },
          // {
          //   label: "更新时间",
          //   prop: "updateTime",
          //   width: 150,
          //   align: "center",
          // },
          // { label: "用户名", prop: "username", width: 150, align: "center" },
        ],
        tableData: [],
      },
      //   分页
      paginationInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  mounted() {
    this.getVoltGetList();
  },
  methods: {
    //   获取表格数据
    getVoltGetList() {
      const params = {
        pageNum: this.paginationInfo.pageNum,
        pageSize: this.paginationInfo.pageSize,
      };
      for (let key in this.queryInfo) {
        if (this.queryInfo[key]) {
          params[key] = this.queryInfo[key];
        }
      }
      this.$http.get("/stealHistory/list", { params }).then((res) => {
        if (res.status == 200) {
          this.tableInfo.tableData = res.data.data.result;
          this.paginationInfo.pageNum = res.data.data.currPage;
          this.paginationInfo.pageSize = res.data.data.pageSize;
          this.paginationInfo.total = res.data.data.total;
        }
      });
    },
    // 切换页码
    handleSizeChange(newSize){
        this.paginationInfo.pageSize = newSize;
        this.getVoltGetList();
    },

    // 切换条数
    handleCurrentChange(newPage){
    this.paginationInfo.pageNum = newPage;
    this.getVoltGetList();
    }
  },
};
</script>

<style lang="less" scoped>
.el-input{
    width: 100%;
}
</style>
